import React, { useMemo } from 'react';
import './CozyBackground.css';

function CozyBackground() {
  const dust = useMemo(() => {
    const arr = [];
    for (let i = 0; i < 24; i++) {
      arr.push({
        left: Math.random() * 100,
        size: 4.2 + Math.random() * 4.2,
        delay: -Math.random() * 18, // negative delay so motes appear mid-flight on load
        duration: 16 + Math.random() * 10,
        drift: -80 + Math.random() * 160,
      });
    }
    return arr;
  }, []);

  const comets = useMemo(() => {
    const arr = [];
    for (let i = 0; i < 1; i++) {
      arr.push({
        top: 5 + Math.random() * 75,
        delay: -Math.random() * 2,
        duration: 7 + Math.random() * 3,
      });
    }
    return arr;
  }, []);

  const shapes = useMemo(() => {
    const types = ['tri', 'sq', 'ring'];
    const arr = [];
    for (let i = 0; i < 8; i++) {
      arr.push({
        type: types[i % types.length],
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: 18 + Math.random() * 28,
        floatDelay: -Math.random() * 20,
        floatDuration: 22 + Math.random() * 18,
        spinDelay: -Math.random() * 16,
        spinDuration: 14 + Math.random() * 16,
        reverse: Math.random() > 0.5,
        driftX: -120 + Math.random() * 240,
        driftY: -100 + Math.random() * 200,
      });
    }
    return arr;
  }, []);

  return (
    <>
      <div className="cozy-bg" aria-hidden="true">
        <div className="cozy-orb cozy-orb-1" />
        <div className="cozy-orb cozy-orb-2" />
        <div className="cozy-orb cozy-orb-3" />
        <div className="cozy-grid" />
      </div>

      <div className="cozy-fg" aria-hidden="true">
        <div className="cozy-pulse" />

        <div className="cozy-shapes">
          {shapes.map((s, i) => (
            <span
              key={i}
              className="cozy-shape-wrap"
              style={{
                left: `${s.left}%`,
                top: `${s.top}%`,
                animationDelay: `${s.floatDelay}s`,
                animationDuration: `${s.floatDuration}s`,
                '--drift-x': `${s.driftX}px`,
                '--drift-y': `${s.driftY}px`,
              }}
            >
              <span
                className={`cozy-shape cozy-shape-${s.type} ${s.reverse ? 'cozy-shape-rev' : ''}`}
                style={{
                  width: `${s.size}px`,
                  height: `${s.size}px`,
                  animationDelay: `${s.spinDelay}s`,
                  animationDuration: `${s.spinDuration}s`,
                }}
              />
            </span>
          ))}
        </div>

        <div className="cozy-dust">
          {dust.map((d, i) => (
            <span
              key={i}
              className="cozy-dust-mote"
              style={{
                left: `${d.left}%`,
                width: `${d.size}px`,
                height: `${d.size}px`,
                animationDelay: `${d.delay}s`,
                animationDuration: `${d.duration}s`,
                '--drift': `${d.drift}px`,
              }}
            />
          ))}
        </div>

        <div className="cozy-comets">
          {comets.map((c, i) => (
            <span
              key={i}
              className="cozy-comet"
              style={{
                top: `${c.top}%`,
                animationDelay: `${c.delay}s`,
                animationDuration: `${c.duration}s`,
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default CozyBackground;
